<template>
    <dd-card
      :wide-content="true"
      id="email-inbox"
      class="flex-stretch justify-content-start"
    >
      <dd-main-table
        v-if="!loading && emails.length > 0"
        id="email-table"
        :headers="headers"
        :rows="emails"
        :skeletonRowLength="25"
        selectKey="id"
        :paginator="pagination"
        :initialLoadPageObject="pagination"
        @load-page="loadPage"
        @update-selected="setSelectedEmails"
        :selected="selectedEmailIds"
        :showPerPage="false"
        actionWidth="200px"
        :style="{flex: emails.length > 0 ? 1 : 0}"
      >
        <template v-slot:actions="{ row }">
          <InboxActions :row="row"/>
        </template>
      </dd-main-table>

      <div
          v-if="!loading && emails.length === 0"
          class="flex-col justify-content-center align-items-center flex-stretch"
      >
        <h3>{{noEmailMessage}}</h3>
      </div>

      <div v-if="loading" class="container-xxl mt-xxl">
        <dd-loading-indicator/>
      </div>
    </dd-card>
</template>

<script>
import AccountStateEnum from "../enums/AccountStateEnum";
import InboxActions from "./email_action_buttons/InboxActions.vue";
import DateAndTimeCell from '~/new_design_components/tables/cell_types/DateAndTimeCell.vue';
import SubjectCell from "./cell_types/SubjectCell.vue";
import SenderCell from "./cell_types/SenderCell.vue";
import {mapActions, mapGetters} from "vuex";


export default {
  name: "InboxComponent.vue",
  components: { InboxActions },
  data() {
    const senderCellWidth = screen.width <= 1200 ? '200px': '295px';
    return {
      headers: [
        {title: 'afzender', key: 'from', typeComponent: SenderCell, width: senderCellWidth},
        {title: 'onderwerp', key: 'subject', typeComponent: SubjectCell},
        {title: 'verzend datum', key: 'date', typeComponent: DateAndTimeCell, width: '140px'}
      ]
    }
  },
  methods: {
    ...mapActions('email', [
      "setSelectedEmails",
      "setPagination",
    ]),
    loadPage(pagination){
      this.setPagination(pagination);
    }
  },
  computed: {
    ...mapGetters("email", [
      "loading",
      "emails",
      "pagination",
      "selectedEmails",
      "accountState",
      "filter",
    ]),
    selectedEmailIds(){
      return this.selectedEmails.map(email => email.id);
    },
    noEmailMessage(){
      if ( this.filter.sender !== "" || this.filter.subject !== ""){
        return "Geen e-mails beschikbaar die voldoen aan het ingestelde filter."
      } else {
        return "Geen e-mails beschikbaar."
      }
    }
  },
  watch:{
    accountState(){
      this.headers[0].title = this.accountState === AccountStateEnum.OUTBOX ? 'ontvanger' : 'afzender';
    }
  }
}

</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.slim-card{
  padding-top: $spacing-md !important;
  padding-bottom: $spacing-md !important;
}
.hidden-card{
  display: none !important;
  height: 0 !important;
  transition: all 1s ease;
}
.show-hidden-card{
  height: auto !important;
  display: block !important;
}
</style>
